import { useSelector } from "react-redux";
import { Popover } from "@remo-co/ui-core/src/components/Popover";
import { useAppDispatch } from "store/hooks";
import { CompaniesList } from "modules/company";
import { hidePopup, selectIsPopupVisible } from "../../redux";
import { useStyles } from "./styles";

export const InEventSwitchCompanyPopup = () => {
  const dispatch = useAppDispatch();
  const isPopupVisible = useSelector(selectIsPopupVisible);
  const styles = useStyles();

  const handlePopupClose = () => {
    dispatch(hidePopup());
  };

  return (
    <Popover
      open={isPopupVisible}
      onClose={handlePopupClose}
      anchorEl={document.body}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
      classes={{ paper: styles.paper }}
    >
      <CompaniesList showTitle onClose={handlePopupClose} />
    </Popover>
  );
};
